export const ease = {
  standard: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
  deceleration: 'cubic-bezier(0.0, 0.0, 0.2, 1)',
  aceleration: 'cubic-bezier(0.4, 0.0, 1, 1)',
  sharp: 'cubic-bezier(0.4, 0.0, 0.6, 1)',
};

export const duration = {
  normal: '350ms',
  fastest: '175ms',
  fast: '250ms',
  slow: '500ms'
};



// WEBPACK FOOTER //
// ./src/core/theme/components/animation.js